<div data-w-id="61f6934822b4a0362d772f45" class="body">
  <div class="page-wrapper">
    <main class="content" [ngSwitch]="page">
      <app-login-form *ngSwitchCase="'login'" 
        (newPageEvent)="changePage($event)">
      </app-login-form>

      <app-set-phone-form *ngSwitchCase="'setPhone'" 
        (newPageEvent)="changePage($event)">
      </app-set-phone-form>

      <app-forgot-password-form *ngSwitchCase="'forgotPassword'" 
        (newPageEvent)="changePage($event)">
      </app-forgot-password-form>

      <app-terms-and-conditions *ngSwitchCase="'termsAndConditions'" 
        (newPageEvent)="changePage($event)">
      </app-terms-and-conditions>

      <app-verify-sms-form *ngSwitchCase="'verifySms'" 
        [previousPage]="previousPage"
        (newPageEvent)="changePage($event)">
      </app-verify-sms-form>
    </main>
    <!-- Start of home page stuff -->
  </div>
</div>
